import { useUserContext } from '../../Contexts/UserConfig'
import { useMessagePopupContext } from '../../garvan-react/Components/ModalFeedback/MessagePopup'
import { useQuery } from 'react-query'
import { tsCodeSetValue } from '../../Typescript/API_Response'
import { AxiosResponse } from 'axios'
import CodeSetService from '../PHP/APIs/CodeSetService'

export function useGetCodeSet(CodeSetName: string) {
  const { whoAmI } = useUserContext()
  const { setError } = useMessagePopupContext()
  return useQuery<any, AxiosResponse>(
    ['CodeSetService', 'getCodeSet', CodeSetName],
    () => CodeSetService.getCodeSet(whoAmI!, CodeSetName),
    {
      onError: (err) => setError(err),
      enabled: !!whoAmI,
      select: (data) => data.values as tsCodeSetValue[],
    },
  )
}

export function useGetKVCodeSet(CodeSetName: string) {
  const { whoAmI } = useUserContext()
  const { setError } = useMessagePopupContext()
  return useQuery<any, AxiosResponse>(
    ['CodeSetService', 'getKVCodeSet', CodeSetName],
    () => CodeSetService.getKVCodeSet(whoAmI!, CodeSetName),
    {
      onError: (err) => setError(err),
      enabled: !!whoAmI,
      select: (data) => data.values as tsCodeSetValue[],
    },
  )
}
